var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNeedInfoBig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 5.88583V11.5329",
    stroke: "#D79304",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 16.0505C11.6237 16.0505 12.1294 15.5449 12.1294 14.9211C12.1294 14.2974 11.6237 13.7917 11 13.7917C10.3762 13.7917 9.87057 14.2974 9.87057 14.9211C9.87057 15.5449 10.3762 16.0505 11 16.0505Z",
    fill: "#D79304"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 20.0035C16.3019 20.0035 20.6 15.7054 20.6 10.4035C20.6 5.10156 16.3019 0.803497 11 0.803497C5.69806 0.803497 1.39999 5.10156 1.39999 10.4035C1.39999 15.7054 5.69806 20.0035 11 20.0035Z",
    stroke: "#D79304",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeedInfoBig);
export default __webpack_public_path__ + "static/media/need_info_big.dfd1d9279505ff0f3069be6db1d050a9.svg";
export { ForwardRef as ReactComponent };